import { SearchContainer } from './../search.container';
import {
    Component, EventEmitter, OnInit, ElementRef, Input, Output,
    ViewChild, Renderer2
} from '@angular/core';
import { SharedContainer } from '../../../shared/shared.container';
import { Router, NavigationEnd } from '@angular/router';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { IRequest } from '../../../core/models/request';
import { IRoomPeople } from '../../../core/models/roompeople';
import { Angulartics2 } from 'angulartics2';
import { Options, LabelType } from 'ng5-slider';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, interval, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ScriptLoader } from '../../../shared/components/scriptLoader';
import { SearchEngineService } from '../../../core/services/search-engine.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
    selector: 'app-desktopform',
    templateUrl: './desktopform.html',
    styleUrls: ['./desktopform.scss'],
    styles: [`
    .custom-day {
      text-align: center;
      padding: 0.285rem 0.35rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
      outline: 0;
    }
    .custom-day:hover {
      background-color: #48a5db;
    }
    .custom-day.focused {
      background-color: #48a5db;
    }
    .custom-day.disabled {
      color: #BCC4F3;
    }
    .custom-day.range, .custom-day:hover {
    }

    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})

export class DesktopFormComponent implements OnInit {

    private facilitiesUrl = `${environment.backendRoot}/webresources/frontend/entity.facilities/`;
    private roomPropertiesUrl = `${environment.backendRoot}/webresources/frontend/entity.roomproperty/`;

    @Input() userLogged;
    @Input() facilitiesGroups;
    @Input() roomFacilities;
    @Input() extraFacilities;
    @Input() flatExperiences;
    @Output() sendRequest: EventEmitter<any> = new EventEmitter();
    @Output() openLoginMOdal: EventEmitter<any> = new EventEmitter();
    @ViewChild('randomClick') randomClick: ElementRef;
    @ViewChild('d2') d2;
    @ViewChild('d1') d1;
    @ViewChild('datepicker') datepicker;
    @ViewChild('myRangeInput') myRangeInput: ElementRef;
    @ViewChild('leavingDate') leavingDateBox: ElementRef;

    experiencesOpen = false;
    facilityGroupsFlat = null;
    requestInfo: IRequest;
    yo = true;
    location: string;
    idvilla: string;

    //  datepicker
    // checkin: NgbDateStruct;
    // checkout: NgbDateStruct;
    personalRequest = '';
    //  slider
    max = 2000;
    min = 5;
    step = 5;
    value = 600;
    numberOfNights = 1;


    //  offer
    duration = 5;
    max2 = 60;
    min2 = 1;
    step2 = 1;
    thumbLabel = true;

    whoModalState = '';
    experiencesModalState = '';
    datesModalState = '';

    rooms = [];
    selectedRoomNumber = 1;
    roompersons: Array<IRoomPeople>;

    activeToolTip = 0;
    confirmVisible = false;
    currentStep = 1;
    numberOfSteps = 4;
    hiddenNextBtn = false;
    heights = ['', '0px', '0px', '0px', '0px'];
    steps = [250, 250, 250];
    maxHeight = 280;
    maxStepsHeight = '280px';
    allFacilities;

    minPrice = 5;
    maxPrice = 10000;
    someRange = [this.minPrice, 10000];

    hoveredDate: NgbDate;

    fromDate: NgbDate;
    toDate: NgbDate;

    // initialization for search button - rooms modal etc...
    toShowFinalChoice: Boolean = false;
    toShowRoomOptions: Boolean = false;

    // initialization for calendars
    day: Number;
    month: Number;
    year: Number;
    minDate: any;
    startDateFrom: any;
    startDateTo: any;
    checkInStartValue: String;
    checkInEndValue: any;
    nights: Number;
    datesSelected: Boolean = false;
    noDatesSelected: Boolean = false;

    requestButtonDisabled: Boolean = false;

    // initialization for sliderBudget
    sliderValueBudget: Number = 3000;
    sliderOptionsBudget: Options = {
        floor: 0,
        ceil: 3000,
        step: 10,
        translate: (value: number, label: LabelType): string => {
            // if (!this.isMobile()) {
            if (value === 3000) {
                return '<b style="color:white;">MAX</b>';
            }
            return '<b style="color:white;">' + value + '</b>' + '<b style="color:white;"> €</b>';
            // } else {
            // return '<b style="color:#0B3C5D;">' + value + '</b>' + '<b style="color:#0B3C5D;"> €</b>';
            // }
        }
    };

    // initialization for sliderRequest
    expiryCounter: any;
    sliderValueRequest: Number = 8;
    sliderOptionsRequest: Options = {
        floor: 0,
        ceil: 22,
        step: 1,
        translate: (value: number, label: LabelType): string => {
            switch (label) {
                case LabelType.Low:
                    if (value === 7) {
                        this.expiryCounter = '1 Day';
                        return '';
                    }
                    if (value < 7) {
                        if (value === 6) { this.expiryCounter = '20 Hours'; }
                        if (value === 5) { this.expiryCounter = '16 Hours'; }
                        if (value === 4) { this.expiryCounter = '12 Hours'; }
                        if (value === 3) { this.expiryCounter = '8 Hours'; }
                        if (value === 2) { this.expiryCounter = '4 Hours'; }
                        if (value === 1) { this.expiryCounter = '2 Hours'; }
                        if (value === 0) { this.expiryCounter = '1 Hours'; }
                        return '';
                    }
                    this.expiryCounter = value - 6 + ' Days';
                    if (value === 21) {
                        this.expiryCounter = '1 Month';
                    } else if (value === 22) {
                        this.expiryCounter = '2 Months';
                    }
                    return '';
                case LabelType.High:
                    return '';
                default:
                    return '';
            }
        }
    };

    // initialization for textarea
    personalRequestText: String;
    personalRequestRemainChars: any = 800;
    personalRequestMaxLength: any = 800;

    allRoomOptions = [
        { id: 1, number: 1 },
        { id: 2, number: 2 },
        { id: 3, number: 3 },
        { id: 4, number: 4 },
        { id: 5, number: 5 },
        { id: 6, number: 6 },
        { id: 7, number: 7 },
        { id: 8, number: 8 },
        { id: 9, number: 9 },
        { id: 10, number: 10 }
    ];
    allRoomOptionsModal = [
        { id: 0, number: 0 },
        { id: 1, number: 1 },
        { id: 2, number: 2 },
        { id: 3, number: 3 },
        { id: 4, number: 4 },
        { id: 5, number: 5 },
        { id: 6, number: 6 },
        { id: 7, number: 7 },
        { id: 8, number: 8 },
        { id: 9, number: 9 },
        { id: 10, number: 10 }
    ];
    roomModalRooms: string;
    roomModalAdults: number;
    roomModalChildren: number;
    whoSelection: string;
    adultsSelection: string;
    adultsSelection2: string;
    adultsSelection3: string;
    adultsSelection4: string;
    adultsSelection5: string;
    adultsSelection6: string;
    adultsSelection7: string;
    adultsSelection8: string;
    adultsSelection9: string;
    adultsSelection10: string;
    childrenSelection: string;
    childrenSelection2: string;
    childrenSelection3: string;
    childrenSelection4: string;
    childrenSelection5: string;
    childrenSelection6: string;
    childrenSelection7: string;
    childrenSelection8: string;
    childrenSelection9: string;
    childrenSelection10: string;

    _htmlForWhoModal: string;
    _finalHtmlForWhoModal: SafeHtml;

    // initialization for request data
    requestForSearch: any;

    // initialization for experiences
    experiencesMappingRest = [
        { id: 7, name: 'Love to explore the local cuisine', checked: false, position: 1 },
        { id: 35, name: 'Looking for pet-friendly accommondation', checked: false, position: 2 },
        { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
        { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
        { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
        { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
        { id: 15, name: 'Wanting a workspace, got some work to do', checked: false, position: 7 },
        { id: 4, name: 'Want to spend precious time with my family', checked: false, position: 8 },
        { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
        { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
        { id: 20, name: 'Would love to be transfered from and to the airport', checked: false, position: 11 },
        { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
        { id: 13, name: 'Host our guests and/or our wedding party', checked: false, position: 13 },
        { id: 8, name: 'Want to experience the local way of life', checked: false, position: 14 },
        { id: 24, name: 'Want to explore the landmarks, sites and local history ', checked: false, position: 15 },
        { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
        { id: 2, name: 'I want to enjoy the warm sun and the golden beaches', checked: false, position: 17 },
        { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
    ];
    selectedExperiences: any;
    toShowExpsOptions: Boolean = false;
    currentSelectedExp: number;


    // initialization for login to results
    sendToAllPressed = false;
    subscription: Subscription;

    dropdownList = [];
    selectedItems = [];
    dropdownSettings: IDropdownSettings = {};

    checkInString: any = 'Check in';
    checkOutString: any = 'Check out';

    userid: any;

    selectedLocation = 'Crete';

    locations = [
        { value: 'Crete', backValue: null },
        { value: 'West Crete', backValue: 'West Crete' },
        { value: 'East Crete', backValue: 'East Crete' }
    ];

    constructor(private router: Router,
        private calendar: NgbCalendar, private searchContainer: SearchContainer, private domSanitizer: DomSanitizer,
        private angulartics2: Angulartics2, private sharedContainer: SharedContainer, private renderer: Renderer2,
        public formatter: NgbDateParserFormatter, private httpClient: HttpClient, private spinner: NgxSpinnerService,
        private scriptLoader: ScriptLoader, private searchService: SearchEngineService) {
        this.location = 'Chania';

        const current = new Date();
        this.minDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };

        this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 1);

        this.setCalendars();
        this.personalRequestText = '';
        this._htmlForWhoModal = '';

        const source = interval(2000);
        this.subscription = source.subscribe(val => {
            if (this.isUserLoggedIn && this.sendToAllPressed) {
                this.getResults('withRequest');
            }
        });
    }
    ngOnInit() {
        this.userid = this.getUserId();
        this.scriptLoader.ngOnInit();
        this.currentSelectedExp = 0;
        this.searchContainer.changeHeader();
        this.initRooms();
        this.roompersons = new Array();
        this.initRoomPerson();

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
        this.whoSelection = this.allRoomOptions[0].number.toString();
        this.adultsSelection = this.allRoomOptions[1].number.toString();
        this.adultsSelection2 = this.allRoomOptions[1].number.toString();
        this.adultsSelection3 = this.allRoomOptions[1].number.toString();
        this.adultsSelection4 = this.allRoomOptions[1].number.toString();
        this.adultsSelection5 = this.allRoomOptions[1].number.toString();
        this.adultsSelection6 = this.allRoomOptions[1].number.toString();
        this.adultsSelection7 = this.allRoomOptions[1].number.toString();
        this.adultsSelection8 = this.allRoomOptions[1].number.toString();
        this.adultsSelection9 = this.allRoomOptions[1].number.toString();
        this.adultsSelection10 = this.allRoomOptions[1].number.toString();
        this.childrenSelection = '0';
        this.childrenSelection2 = '0';
        this.childrenSelection3 = '0';
        this.childrenSelection4 = '0';
        this.childrenSelection5 = '0';
        this.childrenSelection6 = '0';
        this.childrenSelection7 = '0';
        this.childrenSelection8 = '0';
        this.childrenSelection9 = '0';
        this.childrenSelection10 = '0';

        this.roomModalAdults = 2;
        this.roomModalRooms = '1';
        this.roomModalChildren = 0;

        this._finalHtmlForWhoModal = this.domSanitizer.bypassSecurityTrustHtml(
            '<div class="roomOptContainer">'
            + '<div style="display: inline-block;" class="roomNumberOpt"><p>Room 1</p></div>'
            + '<div style="display: inline-block;margin-top:10px;"'
            + 'class="roomAdultsInput"><p>&nbspAdults:&nbsp</p></div><input'
            + ' style="width:40px;background-color:#48c3df;text-align:center;"'
            + 'class="adultsInput" type="number"'
            + 'min="1" id="adultsForRoom onKeyDown="return false" max="10" value="2" />'
            + '<div style="display:inline-block;" class="roomChildrenOpt"><p>Children:&nbsp</p></div>'
            + '<input style="width:40px;background-color:#48c3df;text-align:center;"'
            + 'class="childrenInput" type="number" min="0"'
            + ' id="childrensForRoom onKeyDown="return false" max="10" value="0" /></div>'
        );
        this.selectedExperiences = new Array();
        this.toShowExpsOptions = false;

        this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            // selectAllText: 'Select All',
            // unSelectAllText: 'UnSelect All',
            itemsShowLimit: 2,
            enableCheckAll: false
            // allowSearchFilter: true
        };

        // populate experiences for mobile
        for (let i = 0; i < this.experiencesMappingRest.length; i++) {
            this.dropdownList.push(this.experiencesMappingRest[i].name);
        }

    }

    getRoomProperties(): Observable<any> {
        const url = this.roomPropertiesUrl + 'getAllRoomProperties';
        return this.httpClient.get(url,
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/json')
            }
        );
    }

    datepickertoggle() {
        this.datepicker.toggle();
    }

    addExpToList(expId: string, isChecked: boolean, position: number) {
        const expid = parseInt(expId, 10);

        const element = <HTMLElement>document.getElementById(expId);

        if (isChecked) {
            this.experiencesMappingRest[position - 1].checked = false;
            const index = this.selectedExperiences.indexOf(expId, 0);
            if (index > -1) {
                this.selectedExperiences.splice(index, 1);
                element.classList.remove('expChoiceFocused');
                --this.currentSelectedExp;
            }
        } else {
            if (this.currentSelectedExp === 3) { return; }
            this.experiencesMappingRest[position - 1].checked = true;
            this.selectedExperiences.push(expId);
            element.classList.add('expChoiceFocused');
            ++this.currentSelectedExp;
        }
    }

    onClickedOutside(e: Event) {
        console.log('Clicked outside:', e);
    }

    openExpsModal() {
        this.toShowExpsOptions = true;
    }

    closeExpsModal() {
        this.toShowExpsOptions = false;
    }

    submitExpsModal() {
        this.toShowExpsOptions = false;
    }

    roomSelected() {
        this._htmlForWhoModal = '';
        const selectedRooms = parseInt(this.whoSelection, 10);
        for (let i = 1; i <= selectedRooms; i++) {
            this._htmlForWhoModal += '<div class="roomOptContainer">'
                + '<div style="display:inline-block" class="roomNumberOpt"><p>Room ' + i + '</p></div>'
                + '<div style="display: inline-block;margin-top:10px;"'
                + 'class="roomAdultsInput"><p>&nbspAdults:&nbsp</p></div><input '
                + 'style="width:40px;background-color:#48c3df;text-align:center;"'
                + 'class="adultsInput" type="number"'
                + 'min="1" max="10" id="adultsForRoom' + i + '" value="2" />'
                + '<div style="display:inline-block" class="roomChildrenOpt">'
                + '<p>Children:&nbsp</p></div><input style="width:40px;background-color:#48c3df;text-align:center;"'
                + 'class="childrenInput" type="number" min="0"'
                + ' id="childrensForRoom' + i + '" value="0" max="10" /></div>';
        }
        this._finalHtmlForWhoModal = this.domSanitizer.bypassSecurityTrustHtml(this._htmlForWhoModal);


        for (let j = 2; j <= 10; j++) {
            const elemTmp = <HTMLElement>document.getElementById('roomOptContainer' + j);
            elemTmp.classList.add('hiddenRoom');
        }
        for (let i = 2; i <= selectedRooms; i++) {
            const elem = <HTMLElement>document.getElementById('roomOptContainer' + i);
            elem.classList.remove('hiddenRoom');
        }
        this.submitRoomsModal();
    }

    openRoomsModal() {
        if (this.toShowRoomOptions) {
            this.closeRoomModal();
        } else {
            this.toShowRoomOptions = true;
        }
    }

    closeRoomModal() {
        this.toShowRoomOptions = false;
    }

    submitRoomsModal() {
        this.roomModalRooms = '1';
        this.roomModalAdults = 0;
        this.roomModalChildren = 0;

        // get rooms
        this.roomModalRooms = this.whoSelection;
        // get adults
        /*const adultsSelected = document.querySelectorAll('.adultsInput');
        for (let i = 0; i < adultsSelected.length; i++) {
            const adults = adultsSelected[i].id;
            const adultsOnBox = parseInt((<HTMLInputElement>document.getElementById(adults)).value, 10);
            if (adultsOnBox < 0 || adultsOnBox > 10) {
                this.roomModalRooms = '1';
                this.roomModalAdults = 2;
                this.roomModalChildren = 0;
                this.toShowRoomOptions = false;
                this._finalHtmlForWhoModal = '';
                alert('Please select a value between 0-10 for adults/children');
                return;
            }
            this.roomModalAdults += adultsOnBox;
        }
        // get children
        const childrenSelected = document.querySelectorAll('.childrenInput');
        for (let i = 0; i < childrenSelected.length; i++) {
            const children = childrenSelected[i].id;
            const childrenOnBox = parseInt((<HTMLInputElement>document.getElementById(children)).value, 10);
            if (childrenOnBox < 0 || childrenOnBox > 10) {
                this.roomModalRooms = '1';
                this.roomModalAdults = 2;
                this.roomModalChildren = 0;
                this.toShowRoomOptions = false;
                this._finalHtmlForWhoModal = '';
                alert('Please select a value between 0-10 for adults/children');
                return;
            }
            this.roomModalChildren += parseInt((<HTMLInputElement>document.getElementById(children)).value, 10);
        }

        // close modal and reset
        const allDots = <HTMLElement>document.getElementById('slider__dotsAll');
        allDots.classList.remove('hidden');
        this.toShowRoomOptions = false;
        this._finalHtmlForWhoModal = '';*/
        this.roomModalAdults += parseInt(this.adultsSelection, 10);
        this.roomModalChildren += parseInt(this.childrenSelection, 10);
        for (let i = 2; i <= parseInt(this.roomModalRooms, 10); i++) {
            this.roomModalAdults += parseInt(this['adultsSelection' + i], 10);
            this.roomModalChildren += parseInt(this['childrenSelection' + i], 10);
        }
        // this.toShowRoomOptions = false;

    }

    adultsSelected(val) { }
    childrenSelected(val) { }

    // goes to results page without sending a request
    goToResultsPage() {
        this.getResults('withoutRequest');
    }

    // goes to results page and sends a request to all matching
    sendRequestAndGoToResults() {
        if (!this.isUserLoggedIn()) {
            this.sendToAllPressed = true;
            this.loginUser();
        }
        this.getResults('withRequest');
    }

    sendRequestBtn() {
        this.toShowFinalChoice = true;
    }

    // sets the new calendars
    setCalendars() {

        // set minimum date for search datepicker, start-end range etc....
        const today = new Date();
        const nextDay = today.getDate() + 1;
        this.day = today.getDate();
        this.month = today.getMonth() + 1;
        this.year = today.getFullYear();
        this.minDate = { year: this.year, month: this.month, day: this.day };
        this.startDateFrom = this.minDate;
        this.startDateTo = { year: this.year, month: this.month, day: nextDay };
        this.checkInStartValue = this.year + '-' + this.month + '-' + this.day;
        this.checkInEndValue = this.year + '-' + this.month + '-' + nextDay;
        this.nights = 1;

    }

    /*
      @TODO move this function to a utily module later
    */
    fillRange(size, start) {
        return Array.from(Array(size), (x, i) => (i + start));
    }

    navigate(idvilla) {

        this.router.navigate(['villa-collection/' + idvilla]);
    }

    initRooms() {
        this.rooms = this.fillRange(10, 1);
    }


    initRoomPerson() {
        const roomPeople = {
            adults: 2,
            children: []
        };
        this.roompersons.push(roomPeople);
    }

    setRoomNumber(roomNumber) {
        this.selectedRoomNumber = parseInt(roomNumber.split('m').pop(), 10);
        const childrenSize = this.selectedRoomNumber - this.roompersons.length;
        if (this.selectedRoomNumber > this.roompersons.length) {
            for (let i = 0; i < childrenSize; i++) {
                const roomPeople = {
                    adults: 1,
                    children: []
                };
                this.roompersons.push(roomPeople);
            }
        } else if (this.selectedRoomNumber < this.roompersons.length) {
            for (let i = this.roompersons.length - 1; i >= this.selectedRoomNumber; i--) {
                this.roompersons.pop();
            }
        }
    }


    showConfirm() {
        this.fillRequest();
        if (this.userLogged) {
            this.sendRequest.emit([this.requestInfo]);
        } else {
            this.confirmVisible = true;
        }
    }

    createRequest(el: HTMLElement) {
        el.scrollIntoView({ behavior: 'smooth' });
    }

    sendRequestGuest() {
        this.fillRequest();
        this.sendRequest.emit([this.requestInfo]);
    }

    onslide(event) { }

    fillRequest() {
        // const fromDate = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day + 1);
        // const toDate = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day + 1);

        const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
        const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

        this.requestInfo = {
            location: this.location,
            latitude: 35.5138298,
            longitude: 24.0180367,
            fromdate: fromDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            todate: toDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            maxprice: this.someRange[1],
            minprice: this.someRange[0],
            rooms: this.roompersons.length,
            roompersons: this.fillRoomPersonsRequest(), // this.roompersons,

            roomLift: false,
            disableAccess: false,
            smoking: false,

            roomLiftOpt: false,
            disableAccessOpt: false,
            smokingOpt: 'Both',

            starRating: -1,
            accomType: -1,
            mealType: -1,

            personalReq: this.personalRequest,
            requestExpiry: Date.now() + (this.duration * 1000 * 60 * 60 * 24),
            hotelfacilities: '', // this.filterFacilities(this.facilitiesGroups),
            hotelroomfacilities: '', // this.filterFacilities(this.roomFacilities),
            opthotelfacilities: '', // this.filterFacilities(this.facilitiesGroups),
            opthotelroomfacilities: '', // this.filterFacilities(this.roomFacilities),
            hotelextras: [], // this.filterExtraFacilities(this.extraFacilities)
            userid: -1
        };
    }

    fillRoomPersonsRequest() {
        const roomPeopleReaquest = this.roompersons.map(roomPerson => {
            return { 'adults': String(roomPerson.adults), 'children': roomPerson.children };
        });
        return roomPeopleReaquest;
    }

    showWhoModal() {
        this.whoModalState = 'show';
        this.experiencesModalState = '';
        this.datesModalState = '';
    }

    hideModal() {
        this.whoModalState = '';
        // this.roompersons = [];
    }

    showExperiencesModal() {
        this.experiencesModalState = 'show';
        this.whoModalState = '';
        this.datesModalState = '';
    }

    hideExperiencesModal() {
        this.experiencesModalState = '';
        // this.roompersons = [];
    }

    showDatesModal() {
        this.datesModalState = 'show';
        this.experiencesModalState = '';
        this.whoModalState = '';
    }

    hideDatesModal() {
        this.datesModalState = '';
        // this.roompersons = [];
    }

    filterExtraFacilities(facilityGroup) {
        let facilities = [];
        for (const [key, value] of Object.entries(facilityGroup)) {
            const facilitiesPart = value['facilities'].filter(facility => {
                return facility.isChecked === true;
            });
            facilities = facilities.concat(facilitiesPart);
        }

        const options = facilities.map((facility) => ({ id: facility.id, subcategories: '' }));

        if (options.length < 1) { return []; }
        return options;
    }

    filterFacilities(facilityGroup) {
        let selectedFacilities = [];

        facilityGroup.forEach(facilities => {
            const facilitiesPart = facilities.filter(facility => {
                return facility.isChecked === true;
            });
            selectedFacilities = selectedFacilities.concat(facilitiesPart);
        });

        if (selectedFacilities.length < 1) { return ''; }
        const options = selectedFacilities.reduce((optionsText, currentValue) => {
            if (optionsText.id) { return optionsText.id + ',' + currentValue.id; }
            return optionsText + ',' + currentValue.id;
        });

        return options;
    }

    stdTimezoneOffset() {
        const jan = new Date(2018, 0, 1);
        const jul = new Date(2018, 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    isDstObserved(date) {
        return date.getTimezoneOffset() < this.stdTimezoneOffset();
    }


    setTooltipActive(i) {
        this.activeToolTip = i;
    }

    isStepTooltipActive(step: number) {
        if (step === this.activeToolTip) { return true; }
        return false;
    }

    isDateDisabled(date) {
        const xx = { day: date.day, month: date.month, year: date.year };
        const selectedDate: NgbDate = NgbDate.from(xx);
        const dateObj = new Date();
        const ngbDateStruct = { day: dateObj.getDate(), month: dateObj.getMonth() + 1, year: dateObj.getFullYear() };
        const currentDate = NgbDate.from(ngbDateStruct);
        let isDisabled = true;
        if (xx.year < ngbDateStruct.year) { isDisabled = false; }
        if (xx.year === ngbDateStruct.year) {
            if (xx.month < ngbDateStruct.month) { isDisabled = false; }
            if (xx.month === ngbDateStruct.month) {
                if (xx.day < ngbDateStruct.day) { isDisabled = false; }
            }
        }

        return !isDisabled;
    }

    isEndDateDisabled(date) {
        const xx = { day: date.day, month: date.month, year: date.year };
        if (this === null || this === undefined) { return; }
        if (this.fromDate === null || this.fromDate === undefined) {

        }

        let isDisabled = true;
        if (xx.year < this.fromDate.year) { isDisabled = false; }
        if (xx.year === this.fromDate.year) {
            if (xx.month < this.fromDate.month) { isDisabled = false; }
            if (xx.month === this.fromDate.month) {
                if (xx.day <= this.fromDate.day) { isDisabled = false; }
            }
        }

        return !isDisabled;
    }

    isConfirmVisible() {
        return this.confirmVisible;
    }

    hideNextStepBtn() {
        this.hiddenNextBtn = true;
    }

    showNextStep() {
        this.maxHeight += this.steps[this.currentStep - 1];
        this.currentStep++;
        this.maxStepsHeight = this.maxHeight + 'px';
        this.heights[this.currentStep - 1] = this.steps[this.currentStep - 1] + 'px';
        if (this.numberOfSteps <= this.currentStep) { this.hideNextStepBtn(); }
    }

    isStepVisible(step: number) {
        if (this.currentStep >= step) { return true; }
        return false;
    }

    submitModal() {
        this.whoModalState = '';
        this.experiencesModalState = '';
        this.datesModalState = '';
    }

    saveRoomPeople(roomPeopleInfo) {
        this.roompersons[roomPeopleInfo[0] - 1] = roomPeopleInfo[1];
    }

    getWhoText() {
        let adults = 0;
        let children = 0;
        if (this.roompersons.length > 0) {
            for (const roomPerson of this.roompersons) {
                adults += roomPerson.adults;
                children += roomPerson.children.length;
            }
            // return this.roompersons.length + ' room ' + adults + ' adults ' + children + ' children';
            return { adults, children };
        }
        adults = 2;
        children = 0;
        return { adults, children };
    }

    toggleFacilityButton(id) {
        // if (this.facilitiesGroups[0]) {
        let index = -1;
        let facIndex = -1;
        this.facilitiesGroups.map((facilities, i) => {
            facilities.map((facility, j) => {
                if (facility.id === id) {
                    index = i;
                    facIndex = j;
                }
            });
        });
        if (index === -1) { return; }
        this.facilitiesGroups[index][facIndex].isChecked = !this.facilitiesGroups[index][facIndex].isChecked;
        // }
    }

    toggleFacilityButtonMobile(id) {
        // if (this.facilitiesGroups[0]) {
        let index = -1;
        this.flatExperiences.map((facility, i) => {
            if (facility.id === id) {
                index = i;
            }
        });
        if (index === -1) { return; }
        this.flatExperiences[index].isChecked = !this.flatExperiences[index].isChecked;
        console.log(this.flatExperiences[index]);
        // const el: HTMLElement = this.randomClick.nativeElement as HTMLElement;
        // el.click();
        // }
    }

    isFacilityCheckedMobile(id) {
        const selectedFacility = this.flatExperiences.find(facility => parseInt(facility.id, 10) === parseInt(id, 10));
        if (selectedFacility) { return selectedFacility.isChecked; }
        return false;
    }

    isFacilityChecked(id) {
        // if (this.facilitiesGroups[0]) {

        this.facilitiesGroups.forEach(facilities => {
            const selectedFacility = facilities.find(facility => parseInt(facility.id, 10) === parseInt(id, 10));
            if (id === 5) { }
            if (selectedFacility) { return selectedFacility.isChecked; }
        });

        return false;
    }

    loginUser() {
        this.openLoginMOdal.emit(true);
    }

    filterByPrice() { }

    getFlatExperiences() {
        if (this.facilitiesGroups == null || this.facilitiesGroups === undefined) { return null; }
        if (this.facilityGroupsFlat != null) {
            return this.facilityGroupsFlat;
        } else {
            this.facilityGroupsFlat = [].concat.apply([], this.facilitiesGroups);
        }
    }

    toggleExperiences() {
        console.log(this.experiencesOpen);
        this.experiencesOpen = !this.experiencesOpen;
    }

    isExperincesOpen() {
        return this.experiencesOpen;
    }

    openStartCalendarPopup() {
        // this.d2.close();
        this.d1.toggle();
    }

    openEndCalendarPopup() {
        this.d1.close();
        this.d2.toggle();
    }

    getVisibleExperiences() {
        if (!this.isExperincesOpen()) {
            return 10;
        }
        return this.flatExperiences.length;
    }


    isAfter(date1, date2) {
        let isafter = true;

        if (date1.year < date2.year) { isafter = false; }
        if (date1.year === date2.year) {
            if (date1.month < date2.month) { isafter = false; }
            if (date1.month === date2.month) {
                if (date1.day < date2.day) { isafter = false; }
            }
        }
        return isafter;
    }

    isBefore(date1, date2) {
        let isbefore = true;

        if (date1.year > date2.year) { isbefore = false; }
        if (date1.year === date2.year) {
            if (date1.month > date2.month) { isbefore = false; }
            if (date1.month === date2.month) {
                if (date1.day >= date2.day) { isbefore = false; }
            }
        }
        return isbefore;
    }

    isDatesEqual(date1, date2) {
        if (date1 && date2) {
            return (date1.year === date2.year && date1.month === date2.month && date1.day === date2.day) ? true : false;
        }
        return false;
    }

    async onDateSelection(date: NgbDate) {

        let parsed = '';

        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
            this.toDate = date;
            this.datepickertoggle();
        } else {
            this.toDate = null;
            this.fromDate = date;
        }

        if (this.fromDate !== null && this.toDate !== null) {
            const N1 = Math.floor(275 * this.fromDate.month / 9);
            const N2 = Math.floor((this.fromDate.month + 9) / 12);
            const N3 = (1 + Math.floor((this.fromDate.year - 4 * Math.floor(this.fromDate.year / 4) + 2) / 3));
            const fromN = N1 - (N2 * N3) + this.fromDate.day - 30;

            const N4 = Math.floor(275 * this.toDate.month / 9);
            const N5 = Math.floor((this.toDate.month + 9) / 12);
            const N6 = (1 + Math.floor((this.toDate.year - 4 * Math.floor(this.toDate.year / 4) + 2) / 3));
            const toN = N4 - (N5 * N6) + this.toDate.day - 30;

            if (this.fromDate) {
                // if fromDate is set: add the first date
                parsed += this.formatter.format(this.fromDate);
            }
            /* if (this.toDate) {
              // if toDate is set: add the second date with separator
              parsed += ' - ' + this.formatter.format(this.toDate);
            } */
            // here we update the input value with the new parsed value
            this.renderer
                .setProperty(this.myRangeInput.nativeElement, 'value', this.fromDate.year + '-' +
                    this.fromDate.month + '-' + this.fromDate.day);

            this.nights = toN - fromN;

            this.checkOutString = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

            this.datesSelected = true;
            this.noDatesSelected = false;
        }

    }

    isHovered(date: NgbDate) {
        return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
        return date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
    }

    validateInput(currentValue: NgbDate, input: string): NgbDate {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }


    isMobile() {

        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }

        return false;
    }

    isMobileSmall() {

        const w = window.innerWidth;
        if (w >= 360 && w <= 491) {
            return true;
        }

        return false;
    }

    getDisplayMonths() {
        return this.isMobileSmall() ? 1 : 2;
    }

    isUserLoggedIn() {
        return this.sharedContainer.isLoggedIn$;
    }

    getUserId() {
        const user = localStorage.getItem('user');
        if (user != null) {
            return JSON.parse(user).id;
        }
    }

    angulartics2Track(action: string) {
        this.angulartics2.eventTrack.next({ action: action });
    }

    getResults(sendToAll: String) {

        if (environment.production) {
            const allowed = this.getRequestExpiryCookie('expiryCookie');
            if (allowed !== null && allowed === false) {
                alert('You recently sent a request. Please wait 10 minutes before sending one again!');
                return;
            }
        }

        const currentRoute = this.router.url;

        if (!this.datesSelected) {
            this.noDatesSelected = true;
            const calendar = <HTMLElement>document.getElementById('steps');
            calendar.scrollIntoView({ behavior: 'smooth' });
            return;
        }

        this.spinner.show();

        this.requestButtonDisabled = true;

        const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
        const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

        if (this.isMobile()) {
            this.selectedItems.forEach(item => {
                for (let i = 0; i < this.experiencesMappingRest.length; i++) {
                    if (item.toString() === this.experiencesMappingRest[i].name) {
                        this.selectedExperiences.push(this.experiencesMappingRest[i].id);
                    }
                }
            });
        }

        this.requestForSearch = {
            fromdate: fromDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            todate: toDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            adults: this.roomModalAdults,
            children: this.roomModalChildren,
            hotelextras:  /*this.filterExtraFlatFacilities(this.searchEngineContainer.getFlatExperiences())*/ '',
            offset: 0,
            limit: 10,
            sendRequests: sendToAll,
            experiences: this.selectedExperiences.toString(),
            personalrequest: this.personalRequestText,
            rooms: parseInt(this.roomModalRooms, 10),
            requestexpires: 13,
            origin: this.sharedContainer.userCountry,
            userid: this.userid,
        };
        if (this.selectedLocation !== null) {
            this.requestForSearch.region = this.selectedLocation.toString();
        }

        if (!this.isUserLoggedIn() && sendToAll !== 'withoutRequest') {
            this.angulartics2.eventTrack.next({ action: 'LoginPageFromFlowDesktop' });
            this.spinner.hide();
            this.router.navigate(['login-page'], {
                queryParams: {
                    intent: 'signup',
                    checkInDate: this.requestForSearch.fromdate,
                    checkOutDate: this.requestForSearch.todate,
                    adults: this.roomModalAdults,
                    children: this.roomModalChildren,
                    sendRequests: this.requestForSearch.sendRequests,
                    'experiences': this.selectedExperiences.toString(),
                    // 'optfacilities': [], // this.selectedFacilities.toString(),
                    // 'dailybudget': 1000, // this.sliderValueBudget,
                    'requestexpires': 13,
                    'personalrequest': this.personalRequestText,
                    'region': this.selectedLocation,
                    'rooms': parseInt(this.roomModalRooms, 10),
                    sortby: 'high_to_low'
                }
            });
            this.requestButtonDisabled = false;
            return;
        } else {
            this.sendToAllPressed = false;
        }

        // this.fillRequestForSearch();
        this.angulartics2.eventTrack.next({
            action: 'SearchEngine'
            // properties: { content_ids:  },
        });
        if (!this.router.url.includes('/results')) {
            if (currentRoute === '/testpreview') {
                this.router.navigate(['results/'], {
                    queryParams: {
                        checkInDate: this.requestForSearch.fromdate,
                        checkOutDate: this.requestForSearch.todate,
                        adults: this.roomModalAdults,
                        children: this.roomModalChildren,
                        'experiences': this.selectedExperiences.toString(),
                        'requestexpires': 13,
                        'personalrequest': this.personalRequestText,
                        'region': this.selectedLocation,
                        'rooms': parseInt(this.roomModalRooms, 10),
                        sortby: 'high_to_low'
                    }
                });
            } else {
                this.searchService.sendRequests(this.requestForSearch).subscribe((requestId: any) => {
                    if (requestId !== null) {
                        this.spinner.hide();
                        this.router.navigate(['results/'], {
                            queryParams: {
                                checkInDate: this.requestForSearch.fromdate,
                                checkOutDate: this.requestForSearch.todate,
                                adults: this.roomModalAdults,
                                children: this.roomModalChildren,
                                'experiences': this.selectedExperiences.toString(),
                                // 'optfacilities': this.selectedFacilities.toString(),
                                'personalrequest': this.personalRequestText,
                                'rooms': parseInt(this.roomModalRooms, 10),
                                'region': this.selectedLocation,
                                requestId: requestId,
                                sortby: 'high_to_low'
                            }
                        });
                        // Adwords Conversion
                        if (environment.production) {
                            this.angulartics2.eventTrack.next({
                                action: 'sendrequest',
                                properties: { category: 'req_conversion' }
                            });
                        }
                        this.setRequestExpiryCookie('expiryCookie', false, 600000);
                    }
                });
            }
        } else {
            this.spinner.hide();
            this.router.navigate(['results/'], {
                queryParams: {
                    checkInDate: this.requestForSearch.fromdate,
                    checkOutDate: this.requestForSearch.todate,
                    adults: this.roomModalAdults,
                    children: this.roomModalChildren,
                    // sendRequests: this.requestForSearch.sendRequests,
                    'experiences': this.selectedExperiences.toString(),
                }, queryParamsHandling: 'merge'
            });
            this.hideDatesModal();
            this.hideExperiencesModal();
            this.hideModal();
        }
        this.spinner.hide();
        /*this.fillRequestForSearch();
          this.searchService.getResults(this.requestForSearch).subscribe((data) => {
            console.log(data);
            },
            (error) => console.log(error));*/
    }

    getRequestExpiryCookie(key) {
        const itemStr = localStorage.getItem(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }

    setRequestExpiryCookie(key, value, ttl) {

        const now = new Date();

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

}
